<template>
    <div class="_wrapper">
        <div style="height: 100%;">
            <ul>
                <ShareIcon
                        v-if="shareData.facebook.use"
                        :icon="['fab','facebook']"
                        :text="shareData.facebook.text"
                        background="#4267B2"
                        @click="shareFacebook"
                />
                <ShareIcon
                        v-if="shareData.pintrest.use"
                        :icon="['fab','pinterest']"
                        :text="shareData.pintrest.text"
                        background="#CB2027"
                        @click="sharePintrest"
                />
                <ShareIcon
                        v-if="shareData.linkedin.use"
                        :icon="['fab','linkedin']"
                        :text="shareData.linkedin.text"
                        background="#0077b5"
                        @click="shareLinkedin"
                />
                <ShareIcon
                        v-if="shareData.twitter.use"
                        :icon="['fab','twitter-square']"
                        :text="shareData.twitter.text"
                        background="#55acee"
                        @click="shareTwitter"
                />
                <ShareIcon
                        v-if="shareData.email.use"
                        icon="paper-plane"
                        :text="shareData.email.text"
                        background="#7d7d7d"
                        @click="shareEmail"
                />
<!--                <li  class="_close" @click="toggleShare">-->
<!--                    <font-awesome-icon  icon="angle-left" size="lg" />-->
<!--                </li>-->
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import {EventBus} from "../../../lib/EventBus";
    import ShareIcon from './ShareIcon';

    export default {
        name: "ShareIcons",
        components:{
            ShareIcon
        },
        computed:{
            ...mapGetters([
                'showShareIcons',
                'shareData',
                'project'
            ]),
        },
        watch:{
            showShareIcons(newVal){
                if(newVal){
                    this.slideIn();
                }else{
                    this.slideOut();
                }
            }
        },
        methods:{
            ...mapMutations([
                'toggleShare'
            ]),
            slideIn(){
                //EventBus.$emit('pauseVideo');

                this.$anime.timeline()
                    .add({
                        targets: this.$el,
                        easing: 'linear',
                        left: 0,
                        duration: 400
                    });
            },

            slideOut(){
                //EventBus.$emit('playVideo');

                this.$anime.timeline()
                    .add({
                        targets: this.$el,
                        easing: 'linear',
                        left: '-60px',
                        duration: 400
                    });
            },

            shareFacebook(){
                // https://www.facebook.com/sharer/sharer.php?u=https://app.pixelsmarter.com/api/stripe-charge-event
                let url =  "https://www.facebook.com/sharer/sharer.php?u=" + this.shareData.url;
                this.share(url);
            },

            sharePintrest(){
                // https://pinterest.com/pin/create/button/?url=https://app.pixelsmarter.com/api/stripe-charge-event&media=&description=
                let url =  "https://pinterest.com/pin/create/button/?url=" + this.shareData.url + "&media=" + this.project.image_url;
                if(this.project.description){
                    url += "&description=" + this.project.description
                }
                this.share(url);
            },

            shareLinkedin(){
                // https://www.linkedin.com/shareArticle?mini=true&url=https://app.pixelsmarter.com/api/stripe-charge-event&title=&summary=&source=
                let url = "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent( this.shareData.url );

                if(this.shareData.linkedin.title){
                    url += "&title=" + this.shareData.linkedin.title;
                }

                if(this.project.description){
                    url += "&summary=" + this.project.description;
                }

                this.share(url);
            },

            shareTwitter(){
                // https://twitter.com/home?status=https://app.pixelsmarter.com/api/stripe-charge-event
                const url = "https://twitter.com/intent/tweet?url=" + encodeURIComponent( this.shareData.url );
                this.share(url);
            },

            shareEmail(){
                const url =  "mailto:?subject=" + this.shareData.email.subject + "&body=" + this.shareData.email.body;
                this.share(url);
            },

            share(url){
                //console.log(url);
                window.top.location  = url;
            }
        }
    }
</script>

<style scoped lang="scss">
    ._wrapper {
        height: 100%;
        width: 50px;
        position: absolute;
        top: 15px;
        left: -60px;
        z-index: 4000;
    }

    ._close {
        position: absolute;
        top: 10px;
        right: 15px;
        color: white;
    }

    ul {
        padding: 0;
    }
</style>